
"use client";

import BaseModal from "../common/BaseModal";
import TextInput from "../input/TextInput";
import React, {useContext, useEffect, useState} from "react";
import DefaultButton from "../buttons/DefaultButton";
import NumberInput from "../input/NumberInput";
import SelectInput from "../input/SelectInput";
import TextArea from "../input/TextArea";
import {ValidationContext} from "../contexts/ValidationContext";
import {useAuth} from "../../providers/authProvider";
import {ApiContext} from "../contexts/ApiContext";
import ExtraQuestions from "../input/ExtraQuestions";

function EditChildModal(
    props: {
        openModal: boolean,
        setOpenModal: (arg: boolean) => void,
        setChildren?: any,
        children?: any,
        welcomePage: boolean,
        signUpCode?: string,
        admin?: boolean,
        rowData: any,
        minChildAge?: number,
        maxChildAge?: number,
        childQuestions?: any,
        setChildQuestions?: any,
        locked?: boolean,
    }
) {
    const { token } = useAuth();
    const {Url } = useContext(ApiContext)
    const {nameRegex, nameErrorMessage} = useContext(ValidationContext)
    const [FirstName, setFirstName] = useState('')
    const [LastName, setLastName] = useState('')
    const [Age, setAge] = useState('')
    const [Siblings, setSiblings] = useState('')
    const [Parents, setParents] = useState('')
    const [SintSit, setSintSit] = useState('')
    const [Hobbies, setHobbies] = useState('')
    const [message, setMessage] = useState('')
    const [School, setSchool] = useState('')
    const [ChildID, setChildID] = useState('')
    const [deleteConfirm, setDeleteConfirm] = useState(false)
    const [admin, setAdmin] = useState(false)

    let patchUrl: string;
    if (admin){
        patchUrl = Url + 'admin/children'
    }else{
        patchUrl = Url + 'user/children'
    }

    useEffect(() => {
        if (!props.rowData) return;
        setFirstName(props.rowData.FirstName)
        setLastName(props.rowData.LastName)
        setAge(props.rowData.Age)
        setSiblings(props.rowData.Siblings)
        setParents(props.rowData.Parents)
        setSintSit(props.rowData.SintSit)
        setHobbies(props.rowData.Hobbies)
        setSchool(props.rowData.School)
        setChildID(props.rowData.ID)

        //update all the extra questions with answers given in the rowData 
        if (props.childQuestions && props.rowData.Answers) {
            props.childQuestions.questions.forEach((question: any) => {
                console.log(question)
                let answer = props.rowData.Answers.find((answer: any) => answer.ChildQuestionID === question.ID)
                console.log(answer)
                if (answer) {
                    question.Answer = answer.Answer
                }
            })
        }

        if (props.admin){
            setAdmin(true)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.admin, props.rowData]);

    function handleClose(){
        setMessage('')
        props.setOpenModal(false)
    }

    function editChild(){

        if (FirstName === '' || LastName === '' || Age === '' || Parents === '' ||  Hobbies === ''){
            setMessage('Nog niet alle verplichte velden zijn ingevuld.')
            return
        }
        if (SintSit === '' || SintSit === '0'){
            setMessage('Selecteer een optie bij "Wil dit kind op schoot bij Sinterklaas of Piet?"')
            return
        }
        if (props.welcomePage){
            editChildWelcome()
        }else{
            editChildVisitorPage()
        }

    }

    function editChildWelcome(){
        if (props.maxChildAge !== undefined && Number(Age) > props.maxChildAge) {
            setMessage("De leeftijd van het kind mag niet groter zijn dan " + props.maxChildAge + ".")
            return
        }
        if (props.minChildAge !== undefined && Number(Age) < props.minChildAge) {
            setMessage("De leeftijd van het kind mag niet kleiner zijn dan " + props.minChildAge + ".")
            return
        }
        let child = {
            ID: ChildID,
            FirstName: FirstName,
            LastName: LastName,
            Age: Number(Age),
            Siblings: Siblings,
            Parents: Parents,
            SintSit: SintSit,
            School: School,
            Hobbies: Hobbies,
            Answers: props.childQuestions ? props.childQuestions.questions.map((q: any) => ({
                ...q,
                ChildQuestionID: q.ID
            })) : null,

        }
        let childrenInModal = props.children
        //first remove the child object from the array
        childrenInModal = childrenInModal.filter((children: any) => children.ID !== ChildID)
        //Add the edit child.
        childrenInModal.push(child)
        props.setChildren(childrenInModal)
        //clear state data
        clearData()
        props.setOpenModal(false)
    }
    function editChildVisitorPage(){
        setMessage("Bezig met opslaan...")

        fetch(patchUrl, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            body: JSON.stringify({
                ID: ChildID,
                FirstName : FirstName,
                LastName: LastName,
                Age: Number(Age),
                Parents: Parents,
                Hobbies: Hobbies,
                Siblings: Siblings,
                SintSit: SintSit,
                School: School,
                SignUpCode: props.signUpCode,
                Answers: props.childQuestions ? props.childQuestions.questions.map((q: any) => ({
                    ...q,
                    ChildQuestionID: q.ID
                })) : null,

            }),
        }).then((res) => {
            if (res.status === 200) {
                //Saving successfully.
                setMessage("")
                //clear state data
                clearData()
                //close modal
                props.setOpenModal(false)
            } else {
                //Saving failed
                setMessage("Het opslaan is mislukt, neem contact op.")
            }
        })
    }
    function removeChild(){
        if (props.welcomePage){
            let children = props.children
            props.setChildren(children.filter((children: any) => children.ID !== ChildID))
            props.setOpenModal(false)
            setDeleteConfirm(false)
        }else{
            setDeleteConfirm(false)
            fetch(patchUrl, {
                method: 'DELETE',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                body: JSON.stringify({
                    ID: ChildID,
                }),
            }).then(res => {
                if(res.status === 200 ){
                    props.setOpenModal(false)
                    setMessage("")
                }
                else{
                    setMessage("Verwijderen mislukt")
                }
            })
        }
        //clear state data
        clearData()
    }
    function clearData(){
        setFirstName('')
        setLastName('')
        setAge('')
        setSiblings('')
        setParents('')
        setSintSit('')
        setHobbies('')
    }
    let extraQuestions

    if (props.childQuestions){
        extraQuestions = (
            <ExtraQuestions
                questions={props.childQuestions.questions}
                onChange={(updated: any) => props.setChildQuestions((prev: any) => ({ ...prev, questions: updated }))}
                disabled={props.locked}
            />
        )
    }

    return (
        <BaseModal
            show={props.openModal}
            onClose={() => props.setOpenModal(false)}
            title={`Bewerk ${FirstName} ${LastName}`}
            footer={
                <>
                    <DefaultButton onClick={editChild} content="Wijzigen" disabled={props.locked}/>
                    <DefaultButton onClick={() => setDeleteConfirm(true)} content="Verwijderen" disabled={props.locked}/>
                    <DefaultButton onClick={handleClose} content="Sluiten"/>
                </>
            }
        >
            <p className="text-base leading-relaxed text-gray-500">
                Bewerk de gegevens van het kind op en klik op wijzigen.
            </p>
            <p className="text-base leading-relaxed text-red-500">
                {message}
            </p>
            <TextInput labelName="Voornaam*"
                       inputName="firstName"
                       onChange={(e) => setFirstName(e.target.value)}
                       value={FirstName}
                       placeholder="Voornaam"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <TextInput labelName="Achternaam*"
                       inputName="lastName"
                       onChange={(e) => setLastName(e.target.value)}
                       value={LastName}
                       placeholder="Achternaam"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <NumberInput labelName="Leeftijd*"
                         inputName="age"
                         onChange={(e) => setAge(e.target.value)}
                         value={Age}
                         placeholder="Leeftijd"
                         errorMessage={"Vul hier de leeftijd van het kind in. Gebruik alleen getallen. De minimale leeftijd is: " + (props.minChildAge ?? 0) + " en de maximale leeftijd is: " + props.maxChildAge + "."}
                         max={props.maxChildAge}
                         min={props.minChildAge ?? 0}
                         step="1"
                         disabled={props.locked}
            />
            <TextInput labelName="Naam van broer(s) en/of zus(sen)"
                       inputName="siblings"
                       onChange={(e) => setSiblings(e.target.value)}
                       value={Siblings}
                       placeholder="Naam(en)"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <TextInput labelName="Naam van ouders en/of verzorgers*"
                       inputName="partens"
                       onChange={(e) => setParents(e.target.value)}
                       value={Parents}
                       placeholder="Naam(en)"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <SelectInput labelName={(FirstName ? "Wil " + FirstName : "Wil je kind") + " op schoot bij Sinterklaas of Piet?*"}
                         inputName="sintSit"
                         onChange={(e) => setSintSit(e.target.value)}
                         value={SintSit}
                         errorMessage="Selecteer een van de opties uit de lijst"
                         options={
                             [
                                 {
                                     ID: "Ja leuk",
                                     Name: "Ja leuk"
                                 },
                                 {
                                     ID: "Ja is vorig jaar ook geweest",
                                     Name: "Ja is vorig jaar ook geweest"
                                 },
                                 {
                                     ID: "Waarschijnlijk niet",
                                     Name: "Waarschijnlijk niet"
                                 },
                                 {
                                     ID: "Geen idee",
                                     Name: "Geen idee"
                                 }
                             ]
                         }
                         disabled={props.locked}
            />
            <TextInput labelName="School"
                       inputName="school"
                       onChange={(e) => setSchool(e.target.value)}
                       value={School}
                       placeholder="Naam van de School"
                       errorMessage={nameErrorMessage}
                       pattern={nameRegex}
                       type="text"
                       disabled={props.locked}
            />
            <TextArea labelName="Hobby's en/of sporten*"
                      inputName="hobbies"
                      onChange={(e) => setHobbies(e.target.value)}
                      value={Hobbies}
                      placeholder=""
                      rows={2}
                      disabled={props.locked}
            />
            {extraQuestions}

            {deleteConfirm &&
                <div className="m-4">
                    Weet je zeker dat je {FirstName} {LastName} wilt verwijderen?
                </div>
            }
            {deleteConfirm &&
                <div className="mb-10 grid grid-cols-1 gap-0 md:grid-cols-2">
                    <div className="m-4 flex justify-center">
                        <DefaultButton onClick={removeChild} content="JA" />
                    </div>
                    <div className="m-4 flex justify-center">
                        <DefaultButton onClick={() =>(setDeleteConfirm(false))} content="NEE" />
                    </div>
                </div>
            }
        </BaseModal>
    );
}

export default EditChildModal
